import Vue from 'vue'
import Router from 'vue-router'
import multiguard from 'vue-router-multiguard'

import { authenticated, hasPermission, courseOwner } from './middleware/auth'
import { checkVideoSelected } from './middleware/check-video-selected'
import { checkCourseAvailable } from './middleware/check-course-available'
import { checkLoginToken } from './middleware/check-login-token'

import LayoutUser from '@/components/Layout/User'

import PublicHome from '@/views/Public/Home'
import PublicCoursePage from '@/views/Public/CoursePage'
import PublicSearchCourse from '@/views/Public/SearchCourse'
import InvalidToken from '@/views/Public/Error/InvalidToken'
import Login from '@/views/Public/Login'
import LoginPortal from '@/views/Public/LoginPortal'

// import Certificate from '@/views/User/Certificate'
import CertificateList from '@/views/User/CertificateList'

import UserCourseRegisterStep1 from '@/views/User/CourseRegister/Step1'
import UserCourseRegisterStep2 from '@/views/User/CourseRegister/Step2'
import UserCourseRegisterStep3 from '@/views/User/CourseRegister/Step3'
import UserCourseRegisterStep4 from '@/views/User/CourseRegister/Step4'
import Courses from '@/views/User/Courses'
import UserHome from '@/views/User/Home'
import CoursePage from './views/User/CoursePage'
import Error404 from './views/Public/Error/404'
import UserError404 from '@/views/User/Error/404'
import Log from '@/views/User/Log'
import NewPassword from '@/views/Public/NewPassword'
import TakeCourse from '@/views/User/TakeCourse'
import MyCourses from '@/views/User/MyCourses'
import UserCourseAssociate from '@/views/User/UserCourseAssociate'
import UserRegister from '@/views/User/UserRegister'
import TakeQuiz from '@/views/User/TakeQuiz'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      alias: 'login-enter',
      // name: 'landing',
      // title: 'Home',
      component: Login,
      meta: { title: 'Plataforma digital que dá um play no seu conhecimento!' }
    },
    // {
    //   path: '/sobre-curso/:slug',
    //   name: 'sobre-curso',
    //   title: 'Sobre o Curso',
    //   component: PublicCoursePage,
    //   meta: { title: 'Mais sobre o curso' }
    // },
    // {
    //   path: '/busca',
    //   name: 'busca',
    //   title: 'O que você quer aprender?',
    //   component: PublicSearchCourse,
    //   meta: { title: 'O que você quer aprender?' }
    // },
    {
      path: '/login/:token?',
      name: 'login-enter',
      component: Login,
      meta: { title: 'Entrar no Curso' },
      beforeEnter: multiguard([checkLoginToken])
    },
    {
      path: '/login-portal/:token?',
      name: 'login-portal-enter',
      component: LoginPortal,
      meta: { title: 'Login via Portal' }
    },
    {
      path: '/new-password/:token',
      name: 'user-new-password',
      component: NewPassword,
      meta: { title: 'Nova Senha' }
    },
    {
      path: '/invalid-token',
      name: 'invalid-token',
      title: 'Log',
      menu: false,
      component: InvalidToken,
    },
    {
      path: '/user',
      name: 'user',
      component: LayoutUser,
      beforeEnter: authenticated,
      children: [
        {
          path: '',
          name: 'home',
          title: 'Sua Home',
          menu: true,
          icon: 'home',
          component: UserHome,
          meta: { permissions: ['showVideo'], title: 'Sua Home' },
          beforeEnter: hasPermission
        },
        {
          path: 'cursos',
          name: 'course-list',
          title: 'Cursos',
          menu: true,
          icon: 'videocam',
          component: Courses,
          meta: { permissions: ['showVideo'], title: 'Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'cadastrar-curso/step1/:courseId?',
          name: 'course-create-step1',
          title: 'Cadastro de Curso',
          menu: true,
          icon: 'add_box',
          component: UserCourseRegisterStep1,
          meta: { permissions: ['createVideo'], title: 'Cadastro de Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'cadastrar-curso/step2/:courseId',
          name: 'course-create-step2',
          title: 'Cadastro de Curso',
          menu: false,
          icon: 'add_box',
          component: UserCourseRegisterStep2,
          meta: { permissions: ['createVideo'], title: 'Cadastro de Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'cadastrar-curso/step3/:courseId',
          name: 'course-create-step3',
          title: 'Cadastro de Curso',
          menu: false,
          icon: 'add_box',
          component: UserCourseRegisterStep3,
          meta: { permissions: ['createVideo'], title: 'Cadastro de Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'cadastrar-curso/step4/:courseId',
          name: 'course-create-step4',
          title: 'Cadastro de Curso',
          menu: false,
          icon: 'add_box',
          component: UserCourseRegisterStep4,
          meta: { permissions: ['createVideo'], title: 'Cadastro de Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'meus-cursos',
          name: 'course-my',
          title: 'Meus Cursos',
          menu: true,
          icon: 'account_circle',
          component: MyCourses,
          meta: { permissions: ['createVideo'], title: 'Meus Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'convidar-usuarios',
          name: 'users-associate',
          title: 'Convidar Usuários',
          menu: false,
          icon: 'stars',
          component: UserCourseAssociate,
          meta: { permissions: ['createVideo'], title: 'Associar Usuários ao Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'certificados',
          name: 'certificate',
          title: 'Certificados',
          menu: true,
          icon: 'list_alt',
          component: CertificateList,
          meta: { permissions: ['showVideo'], title: 'Certificados' },
          beforeEnter: hasPermission
        },
        {
          path: 'log',
          name: 'log',
          title: 'Log',
          menu: false,
          icon: 'list',
          component: Log,
          meta: { permissions: ['createVideo'], title: 'Log' },
          beforeEnter: hasPermission
        },
        {
          path: 'user-register',
          name: 'user-register',
          title: 'Meu cadastro',
          menu: false,
          component: UserRegister,
          meta: { title: 'Fazer o curso' }
        },
        {
          path: 'take-course/:course_id',
          name: 'take-course',
          title: 'Fazer o curso',
          menu: false,
          icon: 'videocam',
          component: TakeCourse,
          meta: { permissions: ['showVideo'], title: 'Fazer o curso' },
          beforeEnter: multiguard([hasPermission, checkVideoSelected, checkCourseAvailable])
        },
        // {
        //   path: 'certificate/:course_id',
        //   name: 'course_certificate',
        //   title: 'Certificado',
        //   menu: false,
        //   icon: 'assignment',
        //   component: Certificate,
        //   meta: { permissions: ['showVideo'], title: 'Certificado' },
        //   beforeEnter: multiguard([hasPermission, checkCourseAvailable])
        // },
        {
          path: 'course-page/:slug',
          name: 'course-page',
          title: 'Sobre o Curso',
          menu: false,
          icon: 'videocam',
          component: CoursePage,
          meta: { permissions: ['showVideo'], title: 'Cursos' },
          beforeEnter: hasPermission
        },
        {
          path: 'quiz/:quiz_id',
          name: 'quiz-show',
          title: 'Quiz',
          menu: false,
          icon: '',
          component: TakeQuiz,
          meta: {permissions: ['showVideo'], title: 'Quiz'},
          beforeEnter: hasPermission
        },
        { path: '*', component: UserError404 }
      ]
    },
    { path: '*', component: Error404 }
  ]
})
